module.exports = __webpack_public_path__ + "img/2025-08-16b_6.d0413bcd.jpg";